/**
 *  @class
 *  @function Cart
 */
class Cart {

  constructor() {
    this.container = document.getElementById('Cart');
    this.setupEventListeners();
  }
  onChange(event) {
    if (event.target.type == 'number') {
      if (event.target.dataset.index) {
         this.container.querySelector(`#CartItem-${event.target.dataset.index}`).classList.add('lazyloading');
      }
      console.log(event.target.dataset);
      let oldValue = parseInt(event.target.dataset.value);
      let newValue = parseInt(event.target.value);
      let key = event.target.dataset.key;
      let varient_id=event.target.dataset.variant;
      let customerId=event.target.dataset.customer;
      let product_unit=event.target.dataset.productunit;

      
      let flag = null;  // Initialize flag with null
      let qtyValue = null;  // Initialize flag with null
      if (newValue > oldValue) {
          flag = true;  // Increment
          qtyValue=newValue-1;
      } else {
          flag = false; // Decrement
          qtyValue=newValue+1;
      }

      var base_unit_decriment = null;
     if (product_unit !== 'Each' && product_unit !== null)
      {
        base_unit_decriment=this.extractValue(product_unit);
          if (qtyValue  <  base_unit_decriment) {
              qtyValue = base_unit_decriment;
          }
      }

       console.log(qtyValue);
      console.log(base_unit_decriment);
             
                 
      this.fetchItemVarient(event.target.dataset.product,qtyValue,flag,customerId)
        .then(data => {
          console.log('Variant Data:', data); // Store or process data as needed
          if (data.variant_id) {
            if(data.variant_id === varient_id){
               // Handle case when variant data exists with price_level
               if (oldValue  <  data.base_unit) {
                      oldValue = data.base_unit;
                }
              
                let finalIncrement;
                if (flag) {
                    finalIncrement = oldValue + data.base_unit;
                } else {
                    finalIncrement = oldValue - data.base_unit;
                
                    // Don't let it go below base unit
                    if (finalIncrement < data.base_unit) {
                        finalIncrement = data.base_unit;
                    }
                }
               if (finalIncrement > data.max) {
                  finalIncrement=data.max;
               }
             
               this.updateQuantity(event.target.dataset.index, finalIncrement);
            }else{
               console.log("Another Varient Needed Here");
               this.chnageCartItem(key)
                .then(() => {
                  console.log("Item removed, now adding to cart...");
                  
                  if (oldValue  <  data.base_unit) {
                      oldValue = data.base_unit;
                  }
                  let finalIncrement;
                  if (flag) {
                      finalIncrement = oldValue + data.base_unit;
                  } else {
                      finalIncrement = oldValue - data.base_unit;
                  
                      // Don't let it go below base unit
                      if (finalIncrement < data.base_unit) {
                          finalIncrement = data.base_unit;
                      }
                  }
                  if (finalIncrement > data.max) {
                    finalIncrement=data.max;
                  }
                 
                  this.addToCart(data.variant_id, finalIncrement);
                })
                .catch(error => console.error("Error removing item:", error));
            }
          } else {
            this.updateQuantity(event.target.dataset.index, event.target.value);
          }
        })
        .catch(error => {
          this.updateQuantity(event.target.dataset.index, event.target.value);
        });

    } else if (event.target.getAttribute('id') == 'CartSpecialInstructions') {
      this.saveNotes();
    }
  }
  extractValue(baseUnit) {
    // Match all numbers in the string
    const matches = baseUnit.match(/\d+/g);

    if (!matches || matches.length === 0) {
        return 0;
    }

    // Get the last matched number
    const value = parseInt(matches[matches.length - 1]);

    // Check if the number is followed by 'K'
    const kMatch = new RegExp(`(${value})K`).exec(baseUnit);
    if (kMatch) {
        return value * 1000;
    }

    return value;
}
  fetchItemVarient(productId,qty,flag,customerId) {
    const shopName = Shopify.shop;
    return fetch(`${location.origin}/apps/proxy/findvarientbyproductid?shop=${shopName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ shop: shopName, productId: productId,productName:'', qty:qty,flag:flag,customerId:customerId }),
    })
      .then(response => response.json())
      .catch(error => console.error('Error fetching variant:', error));
  }
  chnageCartItem(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "id": key.toString(), // Replace with the actual line_item_id
        "quantity": 0
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Error removing item from cart: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('Item removed from cart successfully');
    })
    .catch(error => {
      console.error('Error during request:', error);
      throw error;
    });
  }
  
  addToCart(variantId, quantity) {

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
    
      fetch(theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: formData,
      })
      .then(response => response.json())
      .then(response => {
          if (response.status) {
              console.error('Error adding to cart:', response.description);
              return;
          }
          this.refresh();
      })
      .catch(error => console.error('Error:', error));
  }

  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('CartSpecialInstructions').value
      })
    });
  }
  setupEventListeners() {
    this.removeProductEvent();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.termsCheckbox();
  }
  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  displayErrors(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
      this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  updateQuantity(line, quantity) {

    this.container.classList.add('cart-disabled');
    if (line) {
      this.container.querySelector(`#CartItem-${line}`).classList.add('lazyloading');
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }
        this.renderContents(parsedState, line, false);

        this.container.classList.remove('cart-disabled');

        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });
      });
  }
  refresh() {
    this.container.classList.add('cart-disabled');

    let sections = 'main-cart';

    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);


        if (parsedState.errors) {
          this.displayErrors(line, parsedState.errors);
          this.container.classList.remove('cart-disabled');
          return;
        }

        this.renderContents(parsedState, false, true);

        this.container.classList.remove('cart-disabled');
      });
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartTerms'),
      checkout_button = this.container.querySelector('.button.checkout-button');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  renderContents(parsedState, line, refresh) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      if (refresh) {
        if (parsedState[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
        }
      } else {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }

      this.removeProductEvent();

      if (line && this.container.querySelector(`#CartItem-${line}`)) {
        this.container.querySelector(`#CartItem-${line}`).classList.remove('loading');
      }
      this.termsCheckbox();
    }));
  }
}
window.addEventListener('load', () => {
  if (typeof Cart !== 'undefined') {
    new Cart();
  }
});